module.exports = __webpack_public_path__ + "img/SUMO.97fa0897.svg";